import type { UpdateCourseDraft200Instructor } from './updateCourseDraft200Instructor';
import type { UpdateCourseDraft200Level } from './updateCourseDraft200Level';
import type { UpdateCourseDraft200Price } from './updateCourseDraft200Price';
import type { UpdateCourseDraft200SectionsItem } from './updateCourseDraft200SectionsItem';

/**
 * 강의 초안 상세 정보 응답
 */
export type UpdateCourseDraft200 = {
  createdAt?: string;
  /** @nullable */
  description?: string | null;
  /** 강의 초안 ID */
  id: number;
  /** 기본 사용자 정보 */
  instructor?: UpdateCourseDraft200Instructor;
  /** 발행 여부 (초안이므로 항상 false) */
  readonly isPublished?: boolean;
  /** @nullable */
  level?: UpdateCourseDraft200Level;
  /** @nullable */
  price?: UpdateCourseDraft200Price;
  /**
   * 강의 커리큘럼 섹션 목록 (상세 정보 포함)
   * @nullable
   */
  sections?: UpdateCourseDraft200SectionsItem[] | null;
  /** @nullable */
  thumbnailUrl?: string | null;
  title: string;
  updatedAt?: string;
};
